

































































































































































import {
  Component, Vue, Prop,
} from 'vue-property-decorator';
import {
  FilterDTOTypeEnum, CatalogItemFullDTOTypeEnum,
  FilterDTO, SupplierDTO, CatalogItemShortDTO,
} from '@/api';
import services from '@/services';
import Upload from '@/components/common/Upload.vue';
import BackgroundClipping from '@/components/BackgroundClipping.vue';
import ThingTemperatureInput from '@/components/things/ThingTemperatureInput.vue';
import CatalogItemPrice from '@/components/CatalogItemPrice.vue';

interface IForm {
  name: string;
  type: CatalogItemFullDTOTypeEnum | undefined;
  brandId: string | undefined;
  categoryId: number | undefined;
  colorId: number | undefined;
  gender: string | undefined;
  supplierId: string | undefined;
  size: string | undefined;
  price: number;
  priceDiscount: number | undefined;
  thingUrl: string | undefined;
  temperatureFrom: string | undefined;
  temperatureTo: string | undefined;
}

@Component({
  name: 'thing-form',
  components: {
    Upload, BackgroundClipping, ThingTemperatureInput, CatalogItemPrice,
  },
})
export default class Clients extends Vue {
  @Prop({ type: Number, required: true }) index!: number;

  @Prop({ type: Object, required: true }) form!: IForm;

  @Prop({ type: Object }) catalogItem!: CatalogItemShortDTO;

  @Prop({ type: Number }) priceId!: number;

  @Prop({ type: String }) src!: string;

  @Prop({ type: Array, default: () => [] }) categories!: FilterDTO[];

  @Prop({ type: Array, default: () => [] }) brands!: FilterDTO[];

  @Prop({ type: Array, default: () => [] }) suppliers!: SupplierDTO[];

  @Prop({ type: Array, default: () => [] }) thingTypes!: string[];

  @Prop({ type: Array, default: () => [] }) colors!: FilterDTO[];

  @Prop({ type: Array, default: () => [] }) genders!: FilterDTO[];

  @Prop({ type: Boolean, default: false }) editing!: boolean;

  @Prop({ type: Boolean, default: false }) imgLoading!: boolean;

  itemBuffer: CatalogItemShortDTO[] = [];

  loading = false;

  get name() {
    return this.form.name;
  }

  set name(value: string) {
    this.updateForm<'name'>('name', value);
  }

  get type() {
    return this.form.type;
  }

  set type(value: CatalogItemFullDTOTypeEnum | undefined) {
    this.updateForm<'type'>('type', value);
  }

  get brandId() {
    return this.form.brandId;
  }

  set brandId(value: string | undefined) {
    this.updateForm<'brandId'>('brandId', value);
  }

  get categoryId() {
    return this.form.categoryId;
  }

  set categoryId(value: number | undefined) {
    this.updateForm<'categoryId'>('categoryId', value);
  }

  get colorId() {
    return this.form.colorId;
  }

  set colorId(value: number | undefined) {
    this.updateForm<'colorId'>('colorId', value);
  }

  get gender() {
    return this.form.gender;
  }

  set gender(value: string | undefined) {
    this.updateForm<'gender'>('gender', value);
  }

  get supplierId() {
    return this.form.supplierId;
  }

  set supplierId(value: string | undefined) {
    this.updateForm<'supplierId'>('supplierId', value);
  }

  get isSupplierParsed() {
    return this.suppliers.find(s => s.id === this.supplierId)?.parsed;
  }

  get size() {
    return this.form.size;
  }

  set size(value: string | undefined) {
    this.updateForm<'size'>('size', value);
  }

  get price() {
    return this.form.price;
  }

  set price(value: number) {
    this.updateForm<'price'>('price', value);
  }

  get priceDiscount() {
    return this.form.priceDiscount;
  }

  set priceDiscount(value: number | undefined) {
    this.updateForm<'priceDiscount'>('priceDiscount', value);
  }

  get thingUrl() {
    return this.form.thingUrl;
  }

  set thingUrl(value: string | undefined) {
    this.updateForm<'thingUrl'>('thingUrl', value);
  }

  get temperature() {
    return [this.form.temperatureFrom, this.form.temperatureTo];
  }

  set temperature(value) {
    this.updateForm<'temperatureFrom'>('temperatureFrom', value[0]);
    this.updateForm<'temperatureTo'>('temperatureTo', value[1]);
  }

  updateForm<K extends keyof IForm>(propertyName: K, value: IForm[K]) {
    this.$emit('field-change', this.index, propertyName, value);
  }

  checkLink = {
    // eslint-disable-next-line consistent-return
    validator(rule: any, value: any, callback: any) {
      if (!value) {
        return callback(new Error('Введите линк'));
      }
      services.compilationsApi().compilationEndpointParseItemUrl(value)
        .then(({ data }) => data)
        .then((items: any[]) => {
          if (items.length > 0) {
            callback(new Error('Ссылка занята'));
          } else {
            callback();
          }
        })
        .catch(() => {
          callback(new Error('Ссылка занята'));
        });
    },
    trigger: 'blur',
  }

  loadUrl() {
    if (this.thingUrl) {
      this.loading = true;
      services.compilationsApi().compilationEndpointParseItemUrl(this.thingUrl)
        .then(({ data }) => data)
        .then((items) => {
          if (items.length === 1) {
            this.selectCatalogItem(items[0]);
          } else if (items.length > 1) {
            this.itemBuffer = items;
          } else {
            this.$emit('catalog-item', null);
            this.$message({
              type: 'info',
              message: 'Данный товар отсутствует в каталоге',
            });
          }
        })
        .catch((e) => {
          this.$emit('catalog-item', null);
          this.$notify({ title: 'Ошибка! Обратитесь к администратору', message: e, type: 'error' });
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }

  selectPrice(priceId: number) {
    this.$emit('price', priceId);
  }

  selectCatalogItem(item: CatalogItemShortDTO | null) {
    this.$emit('catalog-item', item);
    this.itemBuffer = [];
    this.$message({
      type: 'success',
      message: 'Успешно выбран товар из каталога',
    });
  }

  addSupplier() {
    this.$prompt('Напишите название поставщика', 'Добавление поставщика', {
      confirmButtonText: 'Сохранить',
      cancelButtonText: 'Отмена',
    }).then(async (msg) => {
      const comment = typeof msg === 'object' ? msg.value : '';
      try {
        if (this.suppliers.find(s => s.name === comment)) {
          throw new Error('Такой поставщик уже существует');
        }
        const { data: id } = await services.catalogService().catalogEndpointAddNewSupplier(comment);
        const supplier: SupplierDTO = {
          id, name: comment, parsed: false, partner: false,
        };
        this.$emit('add-supplier', supplier);
        this.supplierId = id;
      } catch (e) {
        this.$notify({ title: 'Ошибка! Обратитесь к администратору', message: e, type: 'error' });
      }
    });
  }

  saveBrand() {
    this.$prompt('Введите название бренда', 'Добавление бренда', {
      confirmButtonText: 'Сохранить',
      cancelButtonText: 'Отмена',
    }).then(async (msg) => {
      const comment = typeof msg === 'object' ? msg.value : '';
      try {
        if (this.brands.find(b => b.name === comment)) {
          throw new Error('Такой бренд уже существует');
        }
        const { data: id } = await services.catalogService().catalogEndpointAddNewBrand(comment);
        this.$emit('add-brand', { id, name: comment, type: FilterDTOTypeEnum.BRAND });
        this.brandId = id;
      } catch (e) {
        this.$notify({ title: 'Ошибка! Обратитесь к администратору', message: e, type: 'error' });
      }
    });
  }

  copy(e: Event) {
    this.$emit('copy', e);
  }

  remove(e: Event) {
    this.$emit('delete', e);
  }

  improveImage(url: string) {
    this.$emit('improve', url);
  }

  openClippingModal() {
    (this.$refs.clippingModal as BackgroundClipping).openWithUrl(this.src);
  }

  onFiles(files: File[]) {
    if (files[0]) {
      this.$emit('file', files[0]);
    }
  }
}
